import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledBrokerLogoLi = styled.li`
    list-style-type: none;
    display: flex;
    height: 72px;
    margin: 0 auto;
    padding: 24px 0;
    justify-content: center;

    img {
        max-height: 72px;
        margin: auto;
    }
`;
export const StyledBrokerWelcomeTextLi = styled.li`
    list-style-type: none;
    padding: 0 25px 15px 25px !important;
    @media ${breakpoints.xs} {
        padding: 0 0 15px 0;
    }

    .lineClamp {
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        line-clamp: 3;
    }

    .welcome-text {
        font-size: var(--size-16);
        color: var(--color-grey-900);

        p {
            margin: 0;
        }
    }
`;
export const StyledSeeMoreLi = styled.li`
    list-style-type: none;
    display: flex;
    align-items: center;
    align-self: flex-end;
    padding-right: 2.5rem;
    margin-bottom: 10px;
    font-size: var(--size-10);
    font-weight: var(--weight-600);
    line-height: 14px;
    color: var(--color-primary);
    text-align: right;
    text-transform: uppercase;
    cursor: pointer;

    svg {
        path {
            fill: var(--color-primary);
        }
    }
`;
